import React from 'react';
import { Field, reduxForm, change } from 'redux-form';
import { connect } from 'react-redux';
import InputNumber from 'components/Fields/ReduxForm/InputNumber';
import { goToStep } from 'actions/kyb';
import * as clevertapKyb from 'clevertap/kyb';
import styles from './style.css';
import Modal from './Modal';

const validate = values => {
  const errors = {};
  if (!values.name) {
    errors.name = 'This field is required';
  } else if (values.name.trim().length < 1) {
    errors.name = 'This field is required';
  }
  if (!values.bankName) {
    errors.bankName = 'This field is required';
  }
  if (!values.accountNumber) {
    errors.accountNumber = 'This field is required';
  } else if (values.accountNumber.trim().length < 1) {
    errors.accountNumber = 'This field is required';
  }
  return errors;
};

const inputField = field => {
  return (
    <div>
      <input
        {...field.input}
        disabled={field.disabled || false}
        type={field.type || 'text'}
        maxLength={field.maxLength}
        className={`form-control ${styles['input-style']} ${
          field.meta.touched && field.meta.error ? styles['input-error'] : ''
        }`}
        placeholder={field.placeholder}
        onKeyPress={e => (field.onKeyPress ? field.setOnlyNumber(e) : '')}
      />
      <small className={styles.error}>
        {field.meta.touched ? field.meta.error : ''}
      </small>
    </div>
  );
};

const renderSelectField = ({ input, meta: { touched, error }, children }) => (
  <div>
    <div>
      <select
        {...input}
        className={`form-control ${styles['input-style']} ${
          touched && error ? styles['input-error'] : ''
        }`}
      >
        {children}
      </select>
      <small className={styles.error}>{touched ? error : ''}</small>
    </div>
  </div>
);

let BankInfo = class BankInfo extends React.Component {
  constructor(props) {
    super(props);
    if (props.data.kybForm.kybData.business_entity_type === 'personal') {
      props.dispatch(
        change('BankInfo', 'name', props.data.kybForm.kybIdentity.KTP_NAME)
      );
    }
    if (props.data.kybForm.kybBankData) {
      this.initializeForm();
    }
  }

  initializeForm() {
    const { kybBankData } = this.props.data.kybForm;
    const initData = {
      name: kybBankData.account_holder_name,
      bankName: kybBankData.bank_id,
      accountNumber: kybBankData.account_holder_number,
    };
    this.props.initialize(initData);
  }

  componentDidMount() {
    $('body').append($('#kybInfo'));
    const {
      phone,
      email,
      business: {
        business_category_id: businessCategory,
        province: businessLocation,
      },
    } = this.props.data.moka.user;
    const {
      business_entity_type: businessEntityType,
      address,
      city,
      kecamatan,
      name: businessName,
      province,
      postal_code: postalCode,
    } = this.props.data.kybForm.kybData;
    const {
      KTP_NAME: NameOnID,
      KTP_NUMBER: IDNumber,
    } = this.props.data.kybForm.kybIdentity;
    const clevertapData = {
      email,
      phone,
      businessCategory,
      businessLocation,
      businessEntityType,
      address,
      city,
      kecamatan,
      businessName,
      province,
      postalCode,
      isKTPPhotoUploaded: true,
      NameOnID,
      IDNumber,
    };
    this.props.appendBusinessOpeningClevertap(clevertapData);
    clevertapKyb.clevertapTracker(
      'KYB Bank Account Information Start',
      clevertapData
    );
  }

  componentWillUnmount() {
    $('#kybInfo').remove();
  }

  goBack = () => {
    const { editMode } = this.props.data.kybForm;
    if (editMode) {
      this.props.dispatch(goToStep(5));
    } else {
      this.props.dispatch(goToStep(3));
    }
  };

  render() {
    const {
      handleSubmit,
      valid,
      data: { kybForm },
    } = this.props;
    const { editMode } = this.props.data.kybForm;
    return (
      <div>
        <form onSubmit={handleSubmit}>
          <div className="col-md-8 col-md-offset-2">
            <h2>{editMode ? 'Edit' : 'Add'} your bank account</h2>
            <div className={`${styles['business-form']}`}>
              <div className="form-group">
                <label>Name on Bank Account</label>
                <Field
                  component={inputField}
                  name="name"
                  placeholder="Name on Bank Account"
                  autoCorrect="off"
                  maxLength="30"
                  autoCapitalize="off"
                  spellCheck="false"
                />
              </div>
              <div className="form-group">
                <label>Bank name</label>
                <Field component={renderSelectField} name="bankName">
                  <option key={0} value="">
                    Select Bank Name
                  </option>
                  {this.props.bankListState.map(option => (
                    <option value={option.id} key={option.id}>
                      {option.name}
                    </option>
                  ))}
                </Field>
              </div>
              <div className="form-group">
                <label>Account Number</label>
                <Field
                  component={InputNumber}
                  name="accountNumber"
                  customErrorClassName={styles['input-error']}
                  placeholder="Account Number"
                  maxLength="30"
                />
              </div>
            </div>
          </div>
          <a
            href="#"
            className={`${styles.info}`}
            data-toggle="modal"
            data-target="#kybInfo"
          >
            How does this work?
          </a>
          <div className={`col-md-8 col-md-offset-2 ${styles['flex-display']}`}>
            <div className={`col-md-6 col-sm-6 col-xs-6 ${styles['form-btn']}`}>
              <button
                className={`btn btn-block btn-default ${styles['back-btn']}`}
                type="button"
                onClick={this.goBack}
              >
                Back
              </button>
            </div>
            <div className={`col-md-6 col-sm-6 col-xs-6 ${styles['form-btn']}`}>
              <button
                className={`btn btn-primary btn-block`}
                disabled={!valid}
                type="submit"
              >
                {editMode ? 'Save Changes' : 'Next'}
              </button>
            </div>
          </div>
        </form>
        <Modal
          title={
            kybForm.kybData.business_entity_type === 'personal'
              ? `Adding your bank account`
              : 'Adding company bank account'
          }
        >
          <div className={`${styles['modal-content']}`}>
            <p>
              Moka will use the bank account information you enter to settle
              funds whenever you receive mobile payment transactions.
            </p>
          </div>
        </Modal>
      </div>
    );
  }
};

BankInfo = reduxForm({
  form: 'BankInfo',
  touchOnBlur: false,
  touchOnChange: true,
  validate,
})(BankInfo);

function select(state) {
  return {
    data: state,
  };
}

export default connect(select)(BankInfo);
